// ── Chargement des dictionnaires i18n ────────────────────────────
// Les traductions vivent dans `locales/<code>.json`, un fichier par langue —
// éditables sans toucher au code, diffables proprement, et confiables à un
// traducteur qui n'est pas développeur.
//
// Chaque fichier accepte DEUX formes de clés, volontairement :
//
//   1. Clés SÉMANTIQUES imbriquées — "landing.hero.ctaPrimary".
//      Forme à utiliser pour tout nouveau texte : la clé décrit l'emplacement
//      et non le contenu, donc reformuler le français ne casse aucune autre
//      langue.
//
//   2. Clés SOURCES à plat — "Vue d'ensemble".
//      Historique du tableau de bord : la clé EST la chaîne française. Toujours
//      supportées pour ne rien réécrire ; à ne plus étendre.
//
// La résolution des clés et le repli entre langues vivent dans LanguageContext.

import fr from './locales/fr.json';
import en from './locales/en.json';
import ar from './locales/ar.json';

export const LANGS = [
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'ar', label: 'العربية', flag: '🇲🇦' },
];

// Langue de repli : toute clé absente d'une langue est cherchée ici avant
// d'abandonner. Le français est la référence du produit — une traduction
// incomplète affiche donc du français lisible, jamais "landing.hero.sub".
export const FALLBACK_LANG = 'fr';

export const TRANSLATIONS = { fr, en, ar };
